import * as React from "react";
import { withRouter } from "react-router-dom";
// import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Link from "../../../Public/Util/Link";
import PasarCarousel from "../../../Public/PasarCarousel";
import { ProductsWrapper } from "../Styled";
import { COLORS } from "../../../../constants/variables";

const topBannerImage = require("../../../../images/ge-top-banner-icons.png");
const bottomBannerImage = require("../../../../images/ge-bottom-logo.png");

class ProductCategories extends React.Component {
  render() {
    const { data } = this.props;
    return (
      <>
        {data.map((item, index) => {
          const {
            title,
            featured_product,
            featured_tag,
            featured_title,
            featured_image_arr,
            featured_redirect_url,
            featured_short_description,
            product_subcategories,
            tag,
            tag_image_arr
          } = item;

          const scheme = index % 2 !== 0
            ? {
              backgroundColor: "#fff",
              color: `${COLORS.primaryBlack}`,
              subColor: `${COLORS.primaryRed}`
            }
            : { backgroundColor: `${COLORS.primaryRed}`, color: "#fff" };

          const image = featured_image_arr && featured_image_arr[0];
          const tagImage = tag_image_arr && tag_image_arr[0];
          const isOpenNewTab = featured_redirect_url.startsWith("http");

          return (
            <ProductsWrapper
              key={`${index}-product-feature`}
              scheme={scheme}
              id={title.toLowerCase()}
              // style={index % 2 == 0 ? {} : { paddingBottom: 150 }}
              className={index % 2 == 0 ? "" : "second-product-wrapper"}
            >
              <div className="wrapper">
                {/* {index % 2 !== 0 && (
                  <Link to="/learnmore/ge" className="top-banner">
                    <img className="top-banner-icons" src={topBannerImage} />
                    <h3 className="top-banner-title">
                      Great Eastern Goes Digital with Aspirasi!
                    </h3>
                    <p className="top-banner-desc">
                      All of our Insurance products are underwritten by Great
                      Eastern Life Assurance! So you know you are in great
                      hands!
                    </p>
                    <span className="action-btn">
                      Learn more
                    </span>
                  </Link>
                )} */}
                <h1 className="title product">
                  {title}
                  <div className="extra-icon">
                    {tag}
                    <img src={tagImage} />
                  </div>
                </h1>
                <h3 className="sub-title">Featured</h3>
                <div className="feature-wrapper">
                  {isOpenNewTab ? (
                    <a
                      target={isOpenNewTab ? "_blank" : ""}
                      href={featured_redirect_url}
                      className="feature-image"
                      style={{ backgroundImage: `url(${image})` }}
                      rel="noreferrer"
                    />
                  ) : (
                    <Link
                      to={featured_redirect_url}
                      className="feature-image"
                      style={{ backgroundImage: `url(${image})` }}
                    />
                  )}

                  <div className="feature-text">
                    <div className="media-sub-title">{featured_tag}</div>
                    <div className="media-title">{featured_title}</div>
                    <div
                      className="media-content"
                      dangerouslySetInnerHTML={{
                        __html: featured_short_description
                      }}
                    />
                    {isOpenNewTab ? (
                      <a
                        href={featured_redirect_url}
                        target="_blank"
                        className="read-more"
                        rel="noreferrer"
                      >
                        Learn more
                        <FiArrowRight />
                      </a>
                    ) : (
                      <Link to={featured_redirect_url} className="read-more">
                        Learn more
                        <FiArrowRight />
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              {product_subcategories.map((item, index) => {
                const { title, top_products } = item;
                return (
                  <PasarCarousel
                    key={`${index}-product-carousel`}
                    title={title}
                    page={top_products}
                    mainColor={scheme.color}
                    subColor={scheme.subColor}
                  />
                );
              })}

              {/* {index % 2 !== 0 && (
                <div className="wrapper">
                  <Link to={'/learnmore/ge'} className="bottom-banner">
                    <img
                      className="bottom-banner-icons"
                      src={bottomBannerImage}
                    />
                    <div className="text-content">
                      <h3 className="bottom-banner-subtitle">
                        ASPIRASI & GREAT EASTERN
                      </h3>
                      <h1 className="bottom-banner-title">
                        The Insurtech Alliance
                      </h1>
                      <p className="bottom-banner-desc">
                        In December 2019, Great Eastern, a regional insurance
                        leader and Aspirasi, a digital financing services
                        provider under Axiata, inked a landmark insurtech
                        alliance to offer innovative, bite-sized insurance to
                        meet a variety of customer's needs in one integrated
                        experience, and to bridge the insurance gap in Malaysia
                      </p>
                      <span className="action-btn">
                        Learn more
                      </span>
                      <p className="bottom-banner-helper">
                        Left: Mr. Khor Hock Seng, Group CEO, Great Eastern
                        Holdings, Right: Mr. Sheyantha Abeykoon, Executive
                        Director of Aspirasi and CFO of Axiata Digital
                      </p>
                    </div>
                  </Link>
                </div>
              )} */}
            </ProductsWrapper>
          );
        })}
      </>
    );
  }
}

export default withRouter(ProductCategories);
